import Button from 'components/form/Button';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import OtpInput from 'react-otp-input';
import { resendOTP, verifyAccount } from 'api/user';

const VerifyEmail = () => {
  window.document.title = 'Verify Email';

  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState('');

  const navigate = useNavigate();

  const email = window.localStorage.getItem('email');

  const handleVerifyOTP = async (email: string, otp: string) => {
    setLoading(true);

    try {
      const res = await verifyAccount(email, otp);

      window.localStorage.setItem('token', res.data);
      navigate('/dashboard');
    } catch (error: any) {
      const { errors } = error.response.data;
      errors.map((err: { error: string }) => {
        return toast.error(err.error);
      });
      console.log(error);
    }
    setLoading(false);
  };

  const resendCode = async () => {
    setLoading(true);

    try {
      await resendOTP(email, 'verify_email');

      toast.success('otp resent to your email');
    } catch (error: any) {
      const { errors } = error.response.data;
      errors.map((err: { error: string }) => {
        return toast.error(err.error);
      });
      console.log(error);
    }
    setLoading(false);
  };

  const onSubmit = () => {
    handleVerifyOTP(email!, otp);
  };
  return (
    <section className="flex h-screen">
      <div className="flex w-full justify-center">
        <div className="hidden h-screen basis-[65%] lg:block">
          <img
            src="/assets/images/chart.jpg"
            alt="card"
            className="h-full w-full object-cover brightness-75"
          />
        </div>
        <div className="my-auto basis-full px-10 md:basis-1/2 lg:basis-[35%]">
          <h3 className="text-brand-blue font-bold">Please check your email</h3>
          <p className="text">A 4 digit OTP code was sent to this email:</p>
          <p className="text-[16px] font-medium">{email}</p>{' '}
          <form className="flex flex-col gap-y-5">
            <div className="flex flex-col gap-y-1">
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} type="number" />}
                inputStyle="!w-[50px] h-[50px] border border-brand-blue mx-1 text-xl rounded-md outline-none"
                inputType="number"
                containerStyle="flex gap-x-2 justify-between my-5 "
              />
            </div>

            <Button
              type="button"
              onClick={() => onSubmit()}
              className="rounded-md bg-blue-500 py-2 text-white"
              disabled={loading || otp.length < 4}
            >
              verify
            </Button>
          </form>
          <br />
          <p className="my-2 mx-auto border"></p>
          <p>
            Did not receive code?{' '}
            <Button className="mx-0 px-0 text-blue-500" onClick={resendCode}>
              resend otp
            </Button>
          </p>
          <p className="mt-2">
            <Link to="/">
              <span className="text-blue-500">blockchain</span>
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default VerifyEmail;
